/*
 * @Author: edvardchen
 * @Date:   2017-05-23 17:59:50
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-05-23 19:21:04
 */

const actionTypes = {
  ACCOUNT_CHANGED: 'ACCOUNT_CHANGED',
};

export { actionTypes };

/* eslint-disable import/prefer-default-export */
export function updateUser(user) {
  return {
    type: actionTypes.ACCOUNT_CHANGED,
    user,
  };
}
